import TaskingIcon from '@apps-common/ui-icons/TaskingDashboard.jsx';
import DateRangeIcon from '@mui/icons-material/DateRange';
import FilterIcon from '@mui/icons-material/FilterList';
import {Box, Button, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

import {showFiltersPanel} from '@explorer/actions/sidebar';
import {showModal} from '@explorer/actions/ui';
import {MODALS} from '@explorer/constants';
import {getSelectedItemTypes} from '@explorer/selectors/item-types';

const Text = props => <Typography align="center" gutterBottom {...props} />;

const OpenButton = props => (
  <Button
    color="primary"
    variant="outlined"
    fullWidth
    sx={{marginY: 1}}
    {...props}
  />
);

const FindMoreResults = props => {
  const {t} = useTranslation();

  return (
    <Box
      sx={{
        paddingX: 2,
      }}
    >
      <Text variant="h6" sx={{fontWeight: 'bold'}}>
        {props.children}
      </Text>
      <Text>
        {props.onlySkySat
          ? t(
              'findMoreResults.taskMessage',
              'Try refining your filters, extending your date range, tasking an image or searching in another location to see more imagery.'
            )
          : t(
              'findMoreResults.message',
              'Try refining your filters, extending your date range, or searching in another location to see more imagery.'
            )}
      </Text>
      {props.onlySkySat && (
        <OpenButton
          onClick={() => props.showModal(MODALS.TASKING)}
          startIcon={<TaskingIcon />}
        >
          {t('findMoreResults.taskButton', 'Task a high res image')}
        </OpenButton>
      )}
      <OpenButton
        onClick={() => props.showFiltersPanel()}
        startIcon={<FilterIcon />}
      >
        {t('findMoreResults.refineFiltersButton', 'Refine filters')}
      </OpenButton>
      <OpenButton
        onClick={() => props.showModal(MODALS.DATE_RANGE)}
        startIcon={<DateRangeIcon />}
      >
        {t('findMoreResults.modifyDateButton', 'Modify date range')}
      </OpenButton>
    </Box>
  );
};

FindMoreResults.propTypes = {
  children: PropTypes.node,
  showFiltersPanel: PropTypes.func,
  showModal: PropTypes.func,
  onlySkySat: PropTypes.bool,
};

const mapStateToProps = state => ({
  onlySkySat: Object.keys(getSelectedItemTypes(state)).every(
    type => type.indexOf('SkySat') >= 0
  ),
});

const mapDispatchProps = {
  showModal,
  showFiltersPanel: () => showFiltersPanel(true),
};

export default connect(mapStateToProps, mapDispatchProps)(FindMoreResults);
